module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/sakae_point3_5-f71dbdf19196cb5b7c79328d81b87281.jpg";